import { render, staticRenderFns } from "./show_batches_production.vue?vue&type=template&id=7fedc473"
import script from "./show_batches_production.vue?vue&type=script&lang=js"
export * from "./show_batches_production.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports